export default {
  patients: {},
  appointments: {
    dashboardStats: {},
  },
  shifts: {},
  shiftConfig: {},
};
